import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentProvidersComponent } from './components/payment-providers/payment-providers.component';
import { PaymentComponent } from './components/payment/payment.component';
import { TranslateModule } from '@ngx-translate/core';
import { OrderModule } from '../order/order.module';
import { environment } from '../../../environments/environment';
import { PaymentInMemoryService } from './services/payment-in-memory.service';
import { PaymentProxyService } from './services/payment-proxy.service';
import { PartnerModule } from '../partner/partner.module';
import { PaymentDiscountComponent } from './components/payment-discount/payment-discount.component';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { PaymentStateService } from './services/payment-state.service';
import { PaymentService } from './services/payment.service';
import { PaymentResultComponent } from './components/payment-result/payment-result.component';
import { RouterModule, Routes } from '@angular/router';
import { PaymentReturnComponent } from './components/payment-return/payment-return.component';
import { PaymentCancelComponent } from './components/payment-cancel/payment-cancel.component';
import { PaymentStartComponent } from './components/payment-start/payment-start.component';
import { PaymentStartGuard } from './guards/payment-start.guard';
import { PaymentCompleteComponent } from './components/payment-complete/payment-complete.component';
import { PaymentCompleteGuard } from './guards/payment-complete.guard';
import { DiscountOdooService } from './services/discount-odoo.service';
import { DiscountInMemoryService } from './services/discount-in-memory.service';
import { DiscountService } from './services/discount.service';
import { DiscountStateService } from './services/discount-state.service';
import { PaymentGiftStateService } from './services/payment-gift-state.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PricelistOdooService } from './services/pricelist-odoo.service';
import { PricelistInMemoryService } from './services/pricelist-in-memory.service';
import { PricelistService } from './services/pricelist.service';
import { PriceListStateService } from './services/pricelist-state.service';
import { PaymentVuService } from './services/payment-vu.service';
import { PaymentOdooService } from './services/payment-odoo.service';
import { InlineSVGModule } from 'ng-inline-svg';

const paymentServiceClass = environment.production ? PaymentProxyService : PaymentInMemoryService;

const discountServiceClass = environment.production ? DiscountOdooService : DiscountInMemoryService;

const pricelistServiceClass = environment.production ? PricelistOdooService : PricelistInMemoryService;

const routes: Routes = [{
  path: 'payment',
  children: [
    {
      path: 'start',
      component: PaymentStartComponent,
      canActivate: [PaymentStartGuard],
      data: { title: ['Payment'] },
    },
    {
      path: 'complete',
      component: PaymentCompleteComponent,
      canActivate: [PaymentCompleteGuard],
      data: { title: ['Confirmation'] },
    },
    {
      path: 'return/:orderid',
      component: PaymentReturnComponent,
    },
    {
      path: 'cancel/:orderid',
      component: PaymentCancelComponent,
    },
    {
      path: 'guest/return/:orderKey/:orderid',
      component: PaymentReturnComponent,
    },
    {
      path: 'guest/cancel/:orderKey/:orderid',
      component: PaymentCancelComponent,
    },
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    OrderModule,
    PartnerModule,
    FormsModule,
    FontAwesomeModule,
    GeneralModule,
    RouterModule.forChild(routes),
    InlineSVGModule,
  ],
  declarations: [
    PaymentProvidersComponent,
    PaymentComponent,
    PaymentDiscountComponent,
    PaymentResultComponent,
    PaymentReturnComponent,
    PaymentCancelComponent,
    PaymentStartComponent,
    PaymentCompleteComponent,
  ],
  exports: [
    PaymentProvidersComponent,
    PaymentComponent,
    PaymentResultComponent,
  ],
  providers: [
    PaymentStateService,
    PaymentStartGuard,
    PaymentCompleteGuard,
    [{ provide: PaymentService, useClass: paymentServiceClass }],
    DiscountStateService,
    [{ provide: DiscountService, useClass: discountServiceClass }],
    PaymentGiftStateService,
    [{ provide: PricelistService, useClass: pricelistServiceClass}],
    PriceListStateService,
    PaymentVuService,
    PaymentOdooService,
  ]
})
export class PaymentModule { }
